import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

const FORBID_TAGS = ['form', 'input', 'style', 'script', 'marquee'];

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    if (node.href && !node.href.startsWith('https://www.fanatical.com')) {
      node.setAttribute('target', '_blank');
    }
  }

  // set all elements owning rel to rel=noopener noreferrer
  if ('rel' in node) {
    if (node.href && !node.href.startsWith('https://www.fanatical.com')) {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  }
});

export default function DangerousHTML({ html, tag: Tag, ...attributes }) {
  return <Tag
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html, { FORBID_TAGS }) }}
    {...attributes}
  />;
}

DangerousHTML.propTypes = {
  html: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

DangerousHTML.defaultProps = {
  html: '',
  tag: 'div',
};
